import { UnfoldMore } from '@mui/icons-material'
import { Components, Theme } from '@mui/material'
import { menuItemIconStyle } from './MuiMenu'

declare module '@mui/material/Select' {
  interface BaseSelectProps {
    'data-is-ai-prefilled'?: boolean
  }
}

export const MuiSelect: Components<Omit<Theme, 'components'>>['MuiSelect'] = {
  defaultProps: {
    displayEmpty: true,
    // TODO - new icon
    IconComponent: UnfoldMore,
    variant: 'standard',
    size: 'medium',
  },
  styleOverrides: {
    select: ({ theme, ownerState }) => {
      const hasValue = Array.isArray(ownerState.value)
        ? ownerState.value.length > 0
        : ownerState.value != null && ownerState.value !== ''
      return {
        color: hasValue ? theme.palette.text.default : theme.palette.text.subtle,
        // The selected option's children are rendered directly into this block-flow
        // container, so an icon/text pair would stack instead of sitting on one row
        '&:has(.MuiListItemIcon-root)': {
          display: 'flex',
          alignItems: 'center',
        },
        '& .MuiListItemIcon-root': menuItemIconStyle(theme),
        '& .MuiListItemText-root': {
          margin: 0,
        },
      }
    },
    icon: ({ theme }) => ({
      color: theme.palette.fg.muted,
      marginRight: theme.spacing(1.5),
    }),
    multiple: ({ theme }) => ({
      '& > .MuiStack-root': {
        gap: theme.spacing(1),
      },
    }),
  },
}
